.y{flex-direction:row;}